import { useMemo } from 'react';

import {
  IEditForm,
  CasEditForm,
  CasRHFNumberField,
  CasStackRow,
} from 'src/compass/shared/components';
import { PropertySchema } from './PropertySchema';

export default function PropertyForm({ row, onSaved }: IEditForm) {
  const defaultValues = useMemo(() => row, [row]);

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity="Sce/Claims/Property"
      schema={PropertySchema}
    >
      <CasStackRow>
        <CasRHFNumberField label="Claims Dashboard Days Left" name="claimsDashboardDaysLeft" />
      </CasStackRow>
      <CasStackRow>
        <CasRHFNumberField label="Fwd Contract Initial Days" name="fwdContractInitialDays" />
      </CasStackRow>
    </CasEditForm>
  );
}
